module.exports = __webpack_public_path__ + "img/LATIN10_23.bc66c5e7.jpg";